import { TextField } from '@material-ui/core';
import React, { Component } from 'react';
import { QuestionTypes } from '../../../../constants/QuestionTypes';
import { getAnswersWithSkip } from '../../../../services/formService';
import { stripPTag } from '../../../common/commonFuncs';
class TypeNumeric extends Component {
	constructor(props) {
		super(props);

		this.state = {
			Question_ID: this.props.Question_ID,
			isTally: this.props.isTally,
			minimumNumber: 0,
			maximumNumber: 1,
		};
	}

	async componentDidMount() {
		let { data: Question_Answers } = await getAnswersWithSkip(this.state.Question_ID);
    const [minimumNumberObj,maximumNumberObj]=Question_Answers;
    const {Answer_Text:minimumNumber} = minimumNumberObj;
    const {Answer_Text:maximumNumber} = maximumNumberObj;
		this.setState({ minimumNumber,maximumNumber });
	}

	handleSave = async () => {
		const { minimumNumber, maximumNumber } = this.state;
		const Question_ID = await this.props.onSave([
			{ Answer_ID: 0, Answer_Text: minimumNumber, SkipLogic: [] },
			{ Answer_ID: 0, Answer_Text: maximumNumber, SkipLogic: [] },
		]);
		this.setState({ Question_ID });
	};

	handleRemove = () => {
		this.props.onRemove();
	};

	handleChange = () => {
		let { isTally } = this.state;
		isTally = !isTally;
		if (isTally) {
			this.props.onTypeChange(QuestionTypes.Numeric_Tally);
		} else {
			this.props.onTypeChange(QuestionTypes.Numeric);
		}
		this.setState({ isTally });
	};

	handleRangeChange = (e) => {
		const { name, value } = e.target;
		const { minimumNumber, maximumNumber } = this.state;

		if ((name === 'minimumNumber' && value < maximumNumber) || (name === 'maximumNumber' && value > minimumNumber)) {
			this.setState({ [name]: value });
		}
	};

	parseToSave = () => {
		let result = [...this.state.Question_Answers];
		result.map((ans) => {
			ans.Answer_Text = stripPTag(ans.Answer_Text);
		});
		return result;
	};

	render() {
		const { minimumNumber, maximumNumber } = this.state;

		return (
			<React.Fragment>
				<div className='form-group'>
					<TextField
						// id={Question_ID + "Description"}
						label='Mininum number'
						value={minimumNumber}
						name='minimumNumber'
						variant='outlined'
						type='number'
						inputProps={{ min: '0' }}
						onChange={(e) => this.handleRangeChange(e)}
					/>
					<TextField
						// id={Question_ID + "Description"}
						label='Maximum Number'
						value={maximumNumber}
						name='maximumNumber'
						variant='outlined'
						type='number'
						inputProps={{ min: '0' }}
						onChange={(e) => this.handleRangeChange(e)}
					/>
				</div>
				<div className='form-check'>
					<input type='checkbox' className='form-check-input' id='isTally' name='tally' checked={this.state.isTally} onChange={this.handleChange} />
					<label htmlFor='isTally' className='form-check-label'>
						Is Tally
					</label>
				</div>

				<div className='float-right'>
					<button className='btn btn-outline-primary m-2' onClick={this.handleSave}>
						Save
					</button>
					<button className='btn btn-outline-danger' onClick={this.handleRemove}>
						Delete
					</button>
				</div>
			</React.Fragment>
		);
	}
}

export default TypeNumeric;
